import { ProblemDetails } from './ProblemDetails';

type ProblemHandler = (problem: ProblemDetails | null) => void;
let globalSetProblem: ProblemHandler | null = null;

export const setGlobalProblemHandler = (handler: ProblemHandler) => {
  globalSetProblem = handler;
};

export const getGlobalSetProblem = () => globalSetProblem;
